import { InlineChildren, Inset, withTheming, Shadows, Spacing, Media } from '@doordash/design-language';
import { NavBarTextAlignment } from './constants.js';
import { NavBarTitleSize } from './types.js';
import styled, { css } from 'styled-components';

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ActionsContainer = styled(InlineChildren).attrs(function () {
  return {
    size: InlineChildren.Sizes.XxSmall,
    alignItems: InlineChildren.Alignment.Center
  };
}).withConfig({
  displayName: "styles__ActionsContainer",
  componentId: "sc-v9lptc-0"
})(["height:100%;flex-shrink:0;", ";&:first-child{margin-left:-", "px;}&:last-child{margin-right:-", "px;}"], function (props) {
  return (// This is to solve an issue with the white background color in the plain buttons rendered for actions
    props.noContentPadding && css(["button{background:transparent;}"])
  );
}, Inset.Sizes.XxSmall, Inset.Sizes.XxSmall);
var ActionWrapper = styled.div.withConfig({
  displayName: "styles__ActionWrapper",
  componentId: "sc-v9lptc-1"
})(["flex-shrink:0;"]);
var TitleContainer = styled.div.withConfig({
  displayName: "styles__TitleContainer",
  componentId: "sc-v9lptc-2"
})(["display:flex;align-items:center;flex-grow:1;min-width:0;", ";"], function (_ref) {
  var textAlign = _ref.textAlign;
  return textAlign === NavBarTextAlignment.Center ? 'justify-content: center' : undefined;
});
var NavBarContainer = withTheming(styled.nav.withConfig({
  displayName: "styles__NavBarContainer",
  componentId: "sc-v9lptc-3"
})(["", ";", ";padding:", ";", ""], function (props) {
  return props.isRaised && css(["box-shadow:", ";"], Shadows.Base);
}, function (props) {
  return props.isSeparatorVisible && css(["border-bottom:1px solid ", ";"], props.theme.Colors.BorderPrimary);
}, function (props) {
  return props.noContentPadding ? "0px" : props.useDynamicPadding ? "".concat(props.theme.Spacing.NavBarPaddingVerticalLarge, "px ").concat(props.theme.Spacing.NavBarPaddingHorizontalLarge, "px") : "".concat(Spacing.Small, "px");
}, function (props) {
  return props.useDynamicPadding && !props.noContentPadding && css(["", " ", ""], Media.Tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding:\n      ", "px ", "px};\n  "])), props.theme.Spacing.NavBarPaddingVerticalMedium, props.theme.Spacing.NavBarPaddingHorizontalMedium), Media.Mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding:\n      ", "px ", "px};\n  "])), props.theme.Spacing.NavBarPaddingVerticalSmall, props.theme.Spacing.NavBarPaddingHorizontalSmall));
}));
var UpperNavBarContainer = styled.div.withConfig({
  displayName: "styles__UpperNavBarContainer",
  componentId: "sc-v9lptc-4"
})(["display:flex;align-items:", ";> * + *{margin-left:", "px;}"], function (_ref2) {
  var titleSize = _ref2.titleSize;
  return titleSize === NavBarTitleSize.Small ? 'center' : 'flex-start';
}, Inset.Sizes.Small);
var LowerNavBarContainer = styled.div.withConfig({
  displayName: "styles__LowerNavBarContainer",
  componentId: "sc-v9lptc-5"
})(["display:flex;align-items:center;", ";"], function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign === NavBarTextAlignment.Center ? 'justify-content: center' : undefined;
});

export { ActionWrapper, ActionsContainer, LowerNavBarContainer, NavBarContainer, TitleContainer, UpperNavBarContainer };
